import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Must stay before the app imports: cascade position of the retired voice app's global CSS.
import "./shared/legacy-global.css";
import { DailyQuestionApp } from "@/daily-question";
import { AssessmentApp } from "@/assessment";
import { SurveyApp } from "@/survey";
import { AnalyzeApp } from "./analyze/AnalyzeApp";
import { MeApp } from "@/me/MeApp";
import { AppRoot } from "@/app/AppRoot";
import { EsignApp } from "@/esign/EsignApp";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/daily-question/*" element={<DailyQuestionApp />} />
        <Route path="/assessment/*" element={<AssessmentApp />} />
        <Route path="/survey/*" element={<SurveyApp />} />
        <Route path="/analyze/*" element={<AnalyzeApp />} />
        <Route path="/esign/:token" element={<EsignApp />} />
        <Route path="/esign/:token/signed-copy" element={<EsignApp />} />
        {/* /me couple-onboarding — its own auth context, outside the homebase
            AuthGate (Option A). */}
        <Route path="/me/*" element={<MeApp />} />
        <Route path="/*" element={<AppRoot />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
